import { Component, OnInit, OnDestroy } from '@angular/core';
import Measurement from "@arcgis/core/widgets/Measurement";
import { MapService } from "../../view/services/map.service";

@Component({
  selector: 'app-measurement',
  templateUrl: './measurement.component.html',
  styleUrls: ['./measurement.component.css']
})
export class MeasurementComponent implements OnInit, OnDestroy {

  measurementWidget = new Measurement();

  constructor(protected mapService: MapService) { }
  ngOnDestroy(): void {
    this.measurementWidget.clear();
  }

  ngOnInit(): void {
    this.measurementWidget.view = this.mapService.getViewMap();
    this.measurementWidget.areaUnit = "metric";
    this.measurementWidget.linearUnit = "metric";
    this.measurementWidget.container = 'measurementWidget';
  }

  measureDistance() {
    this.measurementWidget.activeTool = "distance";
  }

  measureArea() {
    this.measurementWidget.activeTool = "area";
  }
}
